import { render, staticRenderFns } from "./PayrunAudienceSetting.vue?vue&type=template&id=438d446e&scoped=true"
import script from "./PayrunAudienceSetting.vue?vue&type=script&lang=js"
export * from "./PayrunAudienceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d446e",
  null
  
)

export default component.exports